<template>
  <div>
    <van-tabs style="width: 100%;padding-top: 88px" color="#1875f8" line-width="15px" line-height="3px" title-active-color="#1875f8"
              offset-top="88px" duration="0.5" v-model="active" animated sticky swipeable v-if="stNRes.data">
      <van-tab v-for="(data,index) in stNRes.data" :title="data.name" :title-style="'font-size:15px;'+(active===index?'font-weight:border':'')">

        <div class="bodyBox">
          <div v-for="(dataSon,indexSon) in stNRes.data" v-if="active === index && index === indexSon"
               :key="indexSon">
            <van-pull-refresh v-model="refreshing[index]" @refresh="onRefresh(data,index)">
              <van-list v-model="loading[index]" :finished="finished[index]" finished-text="没有更多了"
                        @load="onLoad(data,index)">
                <lazy-component>
                <div class="stBoxOutSide">

                  <div v-for="(value,indexSS) in list[index]" class="stBox" :key="indexSS">

                    <div class="stBoxIn" @click="$stDetailJump(value.id)" v-if="value.symbol">

                      <div style="height: 25px;" v-if="value.symbol_cn">

                        <span class="symbolCN">{{ value.symbol_cn }}</span>
                        <div class="direction"
                             :style="value.trading_direction_id===1?'background-color: #f84242;':'background-color: #2eba94;'">
                          {{ value.trading_direction_id_CN }}
                          <svg-icon :icon-class="value.trading_direction_id===1?'stUp':'stDown'"
                                    style="width:6px;height:7px;padding-bottom: 3px"></svg-icon>
                        </div>


                        <div :class="points[indexSS]<0?'diffGreen':'diffRed'">
                          {{ points[indexSS] }}点
                        </div>


                        <span class="dateShow">
                              {{ $stDateChange(value.release_time_check) }}
                            </span>
                      </div>

                      <div style="height: 20px;">
                            <span class="symbol">
                              {{ value.symbol }}
                            </span>

                        <div class="polSt"
                             :style="value.policy_status===1?'color : #196ddc':value.policy_status===2?'color:#f84242':'color:#2eba94'">
                          {{ value.policy_status === 1 ? '持仓中' : value.policy_status === 2 ? '已止盈' : '已止损' }}
                        </div>
                      </div>

                      <div style="height: 49px">
                        <div class="leftBox" v-if="priceData[value.symbol]">

                          <div class="symbolBox"
                               :style="'color:'+(value.symbol && parseFloat(priceData[value.symbol].rateProfit )<0?'#2eba94':'#f84242')">


                            <div class="skr">{{ priceData[value.symbol].strike }}</div>

                            <div class="range">
                              <div>{{ priceData[value.symbol].profit }}</div>
                              <div>{{ priceData[value.symbol].rateProfit }}%</div>
                            </div>


                          </div>
                          <div style="height: 19px">
                            <span class="label">进场价</span>
                            <span class="entryPrice">{{ value.open_price }}</span>
                          </div>

                        </div>

                        <div class="rightBox">

                          <div style="height: 24px;">
                            <span class="targetPriceLabel">目标价范围</span>
                            <span
                                class="targetPrice">{{
                                $accSub(parseFloat(value.tp_price), parseFloat(value.deviation_value))
                              }}-{{ $accAdd(parseFloat(value.tp_price), parseFloat(value.deviation_value)) }}</span>
                          </div>
                          <div style="height: 24px;">
                            <span class="stopPriceLabel">止损价范围</span>
                            <span
                                class="stopPrice">{{
                                $accSub(parseFloat(value.sl_price), parseFloat(value.deviation_value))
                              }}-{{ $accAdd(parseFloat(value.sl_price), parseFloat(value.deviation_value)) }}</span>
                          </div>
                        </div>
                        <div class="line"></div><!--分割线-->
                      </div>


                    </div>

                  </div>


                </div>
                </lazy-component>
              </van-list>
            </van-pull-refresh>
          </div>


        </div>
      </van-tab>
    </van-tabs>


  </div>
</template>

<script>


export default {

  name: "strategyList",
  computed: {
    points() {
      let result = []
      this.list[this.active].forEach(item => {
        if (!this.priceData[item.symbol]) {
          result.push(0)
        } else {
          let priceNow = parseFloat(this.priceData[item.symbol].strike)
          let openPrice = parseFloat(item.open_price)
          let step = parseFloat(item.price_per_point)
          if (isNaN(priceNow) || isNaN(openPrice) || isNaN(step)) {
            result.push(0)
          } else {
            if (parseInt(item.trading_direction_id) === 1) {
              result.push(this.$math.round((priceNow - openPrice) / step))
            } else {
              result.push(this.$math.round((openPrice - priceNow) / step))
            }
          }
        }
      })

      return result
    }

  },
  data() {
    return {
      active: 0,
      list: [],
      loading: [],
      finished: [],
      refreshing: [],
      stNQuery: {},
      stQuery: [],
      stQueryEn: [],
      stNRes: {},
      stRes: [],
      priceData: {},


    }
  },
  methods: {
    onLoad(data, index) {
      if (this.refreshing[index]) {
        this.stRes[index] = {data: {list: []}}
        this.refreshing[index] = false;
      }


      this.stQueryEn[index] = this.$encrypt(this.$genQuery(this.stQuery[index]))
      this.$get(this.$store.state.apiUrl + "/information/Strategy", {qdata: this.stQueryEn[index]}).then(res => {
        this.$forceUpdate();
        this.stRes[index] = res;


        for (let i = 0; i < this.stRes[index].data.list.length; i++) {
          this.list[index].push(this.stRes[index].data.list[i]);
        }

        let symbols = []
        this.stRes[index].data.list.forEach(item => {
          symbols.push(item.symbol)
        })
        this.connectWs(symbols)
        this.$getFreshPrice()
        this.loading[index] = false;
        this.stQuery[index].last_id = this.stRes[index].data.list[this.stRes[index].data.list.length - 1].id;


        if (this.stRes[index].data.list.length === 0 || this.stRes[index].data.list.length % 10 !== 0) {
          this.finished[index] = true;
        }

      }).catch(err => {
        console.log(err)
      })

    },
    onRefresh(data, index) {

      // 清空列表数据
      this.finished[index] = false;
      this.list[index] = [];
      this.stQuery[index].last_id = 0;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading[index] = true;
      this.onLoad(data, index);
      this.$getFreshPrice()
    },

    getStrategyNav() {
      this.stNQuery = this.$encrypt(this.$genQuery(this.stNQuery))
      this.$get(this.$store.state.apiUrl + "/information/StrategyNav", {qdata: this.stNQuery}).then(res => {
        this.stNRes = res
        for (let i = 0; i < this.stNRes.data.length; i++) {
          this.list[i] = []
          this.loading[i] = false;
          this.finished[i] = false;
          this.refreshing[i] = false;
          this.stRes[i] = {data: {list: []}};
          this.stQuery[i] = {
            type: this.stNRes.data[i].type,
            page_size: 10,
            type_id: this.stNRes.data[i].type_id,
            last_id: 0
          }

        }


      }).catch(err => {
        console.log(err)
      })
    },




  },
  created() {
    this.getStrategyNav()
  },
  mounted() {
    this.$getFreshPrice()
    setInterval(() => {
      this.$getFreshPrice()
    }, 1000)
  }


}
</script>

<style scoped>


.bodyBox {
  width: 100%;
  background-color: #f4f6fa;
  /*padding-top: 88px;*/
  /*min-height: 500px;*/

}



</style>
